import { render, staticRenderFns } from "./VesselBuildersTable.vue?vue&type=template&id=43a1eb16&"
import script from "./VesselBuildersTable.vue?vue&type=script&lang=js&"
export * from "./VesselBuildersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports